export default __webpack_public_path__ + "static/media/arnav.dfbd11ec.jpeg";